<script setup lang="ts">
import { ref } from 'vue';
import { EntityListPage, type EntityConfig } from '@botto/core';
import { partnersStore, getPartnersLookup } from '../../api/adapters/accounts';
import type { Partner } from '../../api';

const listRef = ref<InstanceType<typeof EntityListPage> | null>(null);
const partnersLookup = getPartnersLookup();

function updateGridDimensions() {
  listRef.value?.updateGridDimensions();
}

async function onPartnersChanged() {
  await partnersLookup.reload();
}

defineExpose({ updateGridDimensions });

const config: EntityConfig<Partner> = {
  title: 'Партнёр',
  titlePlural: 'Партнеры',
  popupWidth: 640,
  popupHeight: 560,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'legal_entity', caption: 'Юр. лицо' },
    { dataField: 'domain', caption: 'Домен', width: 160 },
    { dataField: 'currency', caption: 'Валюта', width: 90 },
    { dataField: 'contract_number', caption: 'Договор', width: 140 },
    { dataField: 'contract_date', caption: 'Дата договора', dataType: 'date', width: 130 },
    { dataField: 'archived', caption: 'Архив', dataType: 'boolean', width: 80 },
  ],
  fields: [
    { dataField: 'legal_entity', label: 'Юр. лицо', required: true, colSpan: 2 },
    { dataField: 'domain', label: 'Домен', required: true, colSpan: 2 },
    { dataField: 'currency', label: 'Валюта', required: true },
    { dataField: 'contract_number', label: 'Номер договора', required: true },
    {
      dataField: 'contract_date',
      label: 'Дата договора',
      required: true,
      editorType: 'dxDateBox',
      editorOptions: { type: 'date', displayFormat: 'dd.MM.yyyy' },
    },
    { dataField: 'email', label: 'Email', createOnly: true },
    {
      dataField: 'password',
      label: 'Password',
      createOnly: true,
      editorOptions: { mode: 'password' },
    },
    { dataField: 'archived', label: 'Архив', editorType: 'dxCheckBox' },
  ],
};
</script>

<template>
  <EntityListPage
    ref="listRef"
    embedded
    :config="config"
    :store="partnersStore"
    @created="onPartnersChanged"
    @updated="onPartnersChanged"
    @deleted="onPartnersChanged"
  />
</template>
